export default "__VITE_ASSET__024159ab__"